/**
 * custom-collection.js  |  assets/
 */
(function () {
  'use strict';

  // ── Filter drawer ────────────────────────────────
  var filterBtn    = document.getElementById('ccFilterBtn');
  var filterDrawer = document.getElementById('ccFilterDrawer');
  var filterOverlay = document.getElementById('ccFilterOverlay');
  var filterClose  = document.getElementById('ccFilterClose');

  function openFilter() {
    if (!filterDrawer) return;
    filterDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (filterBtn) filterBtn.setAttribute('aria-expanded', 'true');
  }

  function closeFilter() {
    if (!filterDrawer) return;
    filterDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (filterBtn) filterBtn.setAttribute('aria-expanded', 'false');
  }

  if (filterBtn)     filterBtn.addEventListener('click', openFilter);
  if (filterOverlay) filterOverlay.addEventListener('click', closeFilter);
  if (filterClose)   filterClose.addEventListener('click', closeFilter);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeFilter();
  });

  // ── Filter group accordions ──────────────────────
  document.querySelectorAll('.cc-filter-group__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var body = btn.nextElementSibling;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      body.hidden = open;
    });
  });

  // ── Sort select ──────────────────────────────────
  var sortSelect = document.getElementById('ccSortSelect');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  // ── Hide any theme wishlist buttons injected into cards ──
  function hideWishlistBtns() {
    var selectors = [
      '[class*="wishlist"]',
      '[class*="bookmark"]',
      '[aria-label*="wishlist"]',
      '[aria-label*="Wishlist"]',
      '[aria-label*="Save"]',
      '[data-wishlist]',
      '.product-card__wishlist',
      '.card__wishlist'
    ];
    selectors.forEach(function(sel) {
      document.querySelectorAll('.cc-card ' + sel).forEach(function(el) {
        el.style.setProperty('display', 'none', 'important');
      });
    });
  }

  hideWishlistBtns();

  // Re-run after any DOM mutations (theme may inject dynamically)
  if (window.MutationObserver) {
    var obs = new MutationObserver(hideWishlistBtns);
    var grid = document.getElementById('ccGrid');
    if (grid) obs.observe(grid, { childList: true, subtree: true });
  }

  // ── Color swatch accurate colors ────────────────
  var COLOR_MAP = {
    'black':'#0a0a0a','white':'#ffffff','navy':'#001f5b','navy blue':'#001f5b',
    'blue':'#4a6fa5','dark blue':'#00008b','light blue':'#add8e6','sky blue':'#87ceeb',
    'red':'#c0392b','green':'#3a7d44','dark green':'#006400','forest green':'#228b22',
    'grey':'#808080','gray':'#808080','light grey':'#d3d3d3','dark grey':'#404040',
    'brown':'#795548','pink':'#ffb6c1','hot pink':'#ff69b4','purple':'#8e44ad',
    'yellow':'#f1c40f','orange':'#e67e22','beige':'#f5f5dc','cream':'#f5f0e0',
    'olive':'#808000','olive green':'#6b6914','burgundy':'#800020','wine':'#722f37',
    'camel':'#c19a6b','sand':'#c2b280','charcoal':'#36454f','ivory':'#fffff0',
    'coral':'#ff6b6b','teal':'#008080','mustard':'#e1ad01','rust':'#b7410e',
    'sage':'#b2ac88','sage green':'#77815c','dusty peach':'#e8b4a0','peach':'#ffcba4',
    'alabaster':'#f2f0eb','gray green':'#8fbc8f','grey green':'#8fbc8f',
    'black silver':'#2a2a2a','rose':'#ff007f','gold':'#ffd700','silver':'#c0c0c0',
    'maroon':'#800000','scarlet':'#ff2400','lavender':'#e6e6fa','lilac':'#c8a2c8',
    'mint':'#98ff98','turquoise':'#40e0d0','indigo':'#4b0082','violet':'#ee82ee',
    'khaki':'#c3b091','tan':'#d2b48c','nude':'#e3bc9a','off white':'#f5f2eb',
    'ecru':'#c2b280','mocha':'#967969','coffee':'#6f4e37','terracotta':'#e2725b',
    'cobalt':'#0047ab','royal blue':'#4169e1','denim':'#1560bd','midnight':'#191970',
    'champagne':'#f7e7ce','rose gold':'#b76e79','bronze':'#cd7f32','copper':'#b87333'
  };

  var LIGHT_COLORS = ['#ffffff','#f5f5dc','#fffff0','#f5f0e0','#f2f0eb',
    '#add8e6','#ffb6c1','#e6e6fa','#c8a2c8','#f5f2eb','#f7e7ce','#ffcba4'];

  function applySwatchColors() {
    document.querySelectorAll('.cc-card__swatch').forEach(function(el) {
      var colorName = (el.getAttribute('title') || el.getAttribute('data-color') || '').toLowerCase().trim();
      var hex = COLOR_MAP[colorName];
      if (hex) {
        el.style.backgroundColor = hex;
        el.style.borderColor = LIGHT_COLORS.indexOf(hex) > -1
          ? 'rgba(0,0,0,0.25)'
          : 'transparent';
      }
    });
  }

  applySwatchColors();

})();
